import React from "react";
// import { useEtablissement } from '../../hooks/useEtablissement';

const EtablissementProfilPage = () => {
  // const { etablissement } = useEtablissement()
  return <div>EtablissementProfilPage</div>;
};

export default EtablissementProfilPage;
